import { AxiosResponse } from "axios";
import {
  getHttpStatusClass,
  HttpStatusGoodResponses,
} from "common/utils/universal/http";

export const isAxiosSuccessResponse = (response: AxiosResponse<any, any>) =>
  response.statusText === "OK" ||
  HttpStatusGoodResponses.includes(getHttpStatusClass(response.status)); //For some reason, response.statusText is empty in prod env
